<template>
  <div class="w-full lg:w-[420px] flex flex-col gap-5 kft-product__checkout">
    <EventBuyBox v-if="shouldDisplayEventBuybox" :enable-giftcard="false" />

    <EventGiftcardBuyBoxCard
      v-if="shouldEnableGiftcard"
      display-price
      :type="eventGetters.getIsTeamEvent(eventData) ? 'PRIVATE' : 'PUBLIC'"
      :should-display-buy-box="shouldDisplayEventBuybox"
      :is-special-giftcard-event="isSpecialGiftcardEvent"
    />

    <LazyTeameventRequestCard
      v-if="
        !isSpecialGiftcardEvent &&
        eventGetters.getAttendanceMode(eventData) !== 'NATIONWIDE'
      "
      :price="
        !eventGetters.getNextDateAvailable(eventData) &&
        formatPriceAmount(
          Number(eventGetters.getDefaultPriceAmount(eventData) || 0),
          locale
        )
      "
    />
  </div>
</template>

<script lang="ts" setup>
import type {
  EventCalendarDayMap,
  EventDescription,
} from '~/composables/types/event'
import { useIsSubdomain } from '~/composables/useSubdomain'

const { locale } = useI18n()

const eventData = inject('eventData') as EventDescription
const isSpecialGiftcardEvent = inject('isSpecialGiftcardEvent') as boolean

const isSubdomain = useIsSubdomain()
const calendarDates = ref<EventCalendarDayMap | Record<any, any> | undefined>(
  undefined
)

const areThereDatesAvailable = computed(
  () => Object.values(calendarDates.value || {}).length > 0
)

const shouldEnableGiftcard = computed(
  () =>
    !eventGetters.getIsTeamEvent(eventData) &&
    (!isSubdomain.value ||
      supplierGetters.getHasGiftcardEmbedded(
        eventGetters.getSupplier(eventData)
      ))
)

const shouldDisplayEventBuybox = computed(
  () => !isSpecialGiftcardEvent && areThereDatesAvailable.value
)

const config = useRuntimeConfig()
const { apiBaseURL } = config.public

onMounted(async () => {
  if (isSpecialGiftcardEvent) return
  calendarDates.value = await $fetch(
    `/v1/store/events/${eventGetters.getId(eventData)}/calendar`,
    {
      method: 'GET',
      baseURL: apiBaseURL,
    }
  )
})
</script>
